module.exports = __webpack_public_path__ + "static/e-cohabiter_logo_196-0ff8730d03e701022392b8d0888fc04e.svg";